import { CiCategoriesKey, SourceSegmentsKey } from '../API';

export const checklistOption = [
  {
    id: 1,
    label: '競合情報および市場情報のみ記載されている',
    value: false,
  },
  {
    id: 2,
    label: '自社の活動/自社製品の反響は記載されていない',
    value: false,
  },
  {
    id: 3,
    label: '医療関係者/医療機関/患者さんが特定される情報は記載されていない（講演会案内状を除く）',
    value: false,
  },
  {
    id: 4,
    label: '他社や他社製品の誹謗中傷に当たらない',
    value: false,
  },
  {
    id: 5,
    label: '自社のAE情報を含まない',
    value: false,
  },
  {
    id: 6,
    label: 'その他、プリンシプルベースでの報告になっている',
    value: false,
  },
];

export const postChecklistOptions = [
  ...checklistOption,
  {
    id: checklistOption.length + 1,
    label: '似たような内容を含まない',
    value: false,
    isDuplicateCheck: true,
  },
];

export const commentChecklistOptions = [
  ...checklistOption,
  {
    id: checklistOption.length + 1,
    label: '返信先の投稿に関連する内容が記載されている',
    value: false,
    isDuplicateCheck: false,
  },
];

export const retweetChecklistOptions = [
  ...checklistOption,
  {
    id: checklistOption.length + 1,
    label: '引用元の投稿に関連する内容が記載されている',
    value: false,
    isDuplicateCheck: false,
  },
];

export const sourceSegmentsKeys = ['occupationGroup', 'workplace', 'occupation'] as SourceSegmentsKey[];

export const sourceSegmentsLabel: { [key in SourceSegmentsKey]: string } = {
  occupationGroup: '職種グループ',
  occupation: '職種',
  workplace: '職場',
} as const;

export const ciCategoriesKeys = [
  'diseaseGroup',
  'disease',
  'productGroup',
  'competitiveProduct',
  'category',
  'activity',
] as CiCategoriesKey[];

export const ciCagetoriesLabel: { [key in CiCategoriesKey]: string } = {
  diseaseGroup: '領域',
  disease: '対象疾患',
  productGroup: '薬効分類',
  competitiveProduct: '競合製品',
  category: 'カテゴリ',
  activity: 'アクティビティ',
} as const;

export const defaultDueDateDays = 14;

export const PageSize = 20; // detault: 100

export const errorMessage = {
  userNotFound: 'ユーザーが登録されていないようです...',
} as { [key: string]: string };

export const unknownErrorMessage = '何かがうまくいかなかったようです...';

export const skipIdsOfCategory = [4, 5, 6, 7, 8, 9, 10, 11];
export const skipIdsOfCompetitive = [14, 15, 16];
export const skipIdsOfProduct = [996, 997, 998, 999];
export const skipIdsOfDiseaseToEnd = [5, 6, 9];
export const skipIdOfDisease = 4;

export const skipIdsOfProductGroupJOBU = [999];

export const skipIdsOfOccupationGroupJPBU1 = [6];
export const unskipIdsOfOGJPBU1 = [1];
export const skipIdsOfDiseaseJPBU1 = [3];
export const skipIdsOfProductGroupJPBU1 = [3, 4];
export const covidIdOfDiseaseJPBU1 = [4];
export const skipCategoryIdsOfProductGroupJPBU1 = [2];

export const Database = {
  GIBU: 'cimgibu',
  RDBU: 'cimrdbu',
  JOBU: 'cimjobu',
  JPBU1: 'cimjpbu1',
} as const;
export type Database = (typeof Database)[keyof typeof Database];

export const allDiseaseGroups = {
  cimgibu: { IBD: 1, SBS: 2, TCB: 3 },
  cimrdbu: { RH: 1, RI: 2, RM: 3, PDT: 4 },
  cimjobu: { 'CRC(VCT・FRU)': 1, NIN: 2, ADC: 3, ALB: 4, CAB: 5, OC: 6 },
  cimjpbu1: { TCB: 1, Vaccine: 2, Others: 3 },
} as const;
export type allDiseaseGroups = (typeof allDiseaseGroups)[keyof typeof allDiseaseGroups];

export const allSteps = {
  cimgibu: [
    {
      key: 'occupationGroup',
      title: sourceSegmentsLabel.occupationGroup,
      description: `情報元の${sourceSegmentsLabel.occupationGroup}を選択します`,
      path: 'occupationGroups',
    },
    {
      key: 'workplace',
      title: sourceSegmentsLabel.workplace,
      description: `情報元の${sourceSegmentsLabel.workplace}を選択します`,
      path: 'workplaces',
    },
    {
      key: 'occupation',
      title: sourceSegmentsLabel.occupation,
      description: `情報元の${sourceSegmentsLabel.occupation}を選択します`,
      path: 'occupations',
    },
    {
      key: 'diseaseGroup',
      title: ciCagetoriesLabel.diseaseGroup,
      description: `${ciCagetoriesLabel.diseaseGroup}を選択します`,
      path: 'diseaseGroups',
    },
    {
      key: 'disease',
      title: ciCagetoriesLabel.disease,
      description: `${ciCagetoriesLabel.disease}を選択します`,
      path: 'diseases',
    },
    {
      key: 'productGroup',
      title: ciCagetoriesLabel.productGroup,
      description: `${ciCagetoriesLabel.productGroup}を選択します`,
      path: 'productGroups',
    },
    {
      key: 'competitiveProduct',
      title: ciCagetoriesLabel.competitiveProduct,
      description: `${ciCagetoriesLabel.competitiveProduct}を選択します`,
      path: 'competitiveProducts',
    },
    {
      key: 'category',
      title: ciCagetoriesLabel.category,
      description: `${ciCagetoriesLabel.category}を選択します`,
      path: 'categories',
    },
    {
      key: 'activity',
      title: ciCagetoriesLabel.activity,
      description: `${ciCagetoriesLabel.activity}を選択します`,
      path: 'activities',
    },
    {
      title: '確認',
      description: '選択内容を確認し、問題なければテキストを入力してください',
    },
  ],
  cimrdbu: [
    {
      key: 'diseaseGroup',
      title: 'フランチャイズ',
      description: `フランチャイズを選択します`,
      path: 'diseaseGroups',
    },
    {
      key: 'occupationGroup',
      title: sourceSegmentsLabel.occupationGroup,
      description: `情報元の${sourceSegmentsLabel.occupationGroup}を選択します`,
      path: 'occupationGroups',
    },
    {
      key: 'workplace',
      title: sourceSegmentsLabel.workplace,
      description: `情報元の${sourceSegmentsLabel.workplace}を選択します`,
      path: 'workplaces',
    },
    {
      key: 'occupation',
      title: sourceSegmentsLabel.occupation,
      description: `情報元の${sourceSegmentsLabel.occupation}を選択します`,
      path: 'occupations',
    },
    {
      key: 'disease',
      title: ciCagetoriesLabel.disease,
      description: `${ciCagetoriesLabel.disease}を選択します`,
      path: 'diseases',
    },
    {
      key: 'competitiveProduct',
      title: ciCagetoriesLabel.competitiveProduct,
      description: `${ciCagetoriesLabel.competitiveProduct}を選択します`,
      path: 'competitiveProducts',
    },
    {
      key: 'category',
      title: ciCagetoriesLabel.category,
      description: `${ciCagetoriesLabel.category}を選択します`,
      path: 'categories',
    },
    {
      key: 'activity',
      title: ciCagetoriesLabel.activity,
      description: `${ciCagetoriesLabel.activity}を選択します`,
      path: 'activities',
    },
    {
      title: '確認',
      description: '選択内容を確認し、問題なければテキストを入力してください',
    },
  ],
  cimjobu: [
    {
      key: 'occupationGroup',
      title: sourceSegmentsLabel.occupationGroup,
      description: `情報元の${sourceSegmentsLabel.occupationGroup}を選択します`,
      path: 'occupationGroups',
    },
    {
      key: 'workplace',
      title: sourceSegmentsLabel.workplace,
      description: `情報元の${sourceSegmentsLabel.workplace}を選択します`,
      path: 'workplaces',
    },
    {
      key: 'occupation',
      title: sourceSegmentsLabel.occupation,
      description: `情報元の${sourceSegmentsLabel.occupation}を選択します`,
      path: 'occupations',
    },
    {
      key: 'diseaseGroup',
      title: '製品',
      description: '製品を選択します',
      path: 'diseaseGroups',
    },
    {
      key: 'disease',
      title: ciCagetoriesLabel.disease,
      description: `${ciCagetoriesLabel.disease}を選択します`,
      path: 'diseases',
    },
    {
      key: 'productGroup',
      title: '情報カテゴリ',
      description: `情報カテゴリを選択します`,
      path: 'productGroups',
    },
    {
      key: 'competitiveProduct',
      title: ciCagetoriesLabel.competitiveProduct,
      description: `${ciCagetoriesLabel.competitiveProduct}を選択します`,
      path: 'competitiveProducts',
    },
    {
      key: 'category',
      title: 'CI活動カテゴリ',
      description: 'CI活動カテゴリを選択します',
      path: 'categories',
    },
    {
      key: 'activity',
      title: 'CI活動',
      description: 'CI活動を選択します',
      path: 'activities',
    },
    {
      title: '確認',
      description: '選択内容を確認し、問題なければテキストを入力してください',
    },
  ],
  cimjpbu1: [
    {
      key: 'diseaseGroup',
      title: 'フランチャイズ',
      description: `フランチャイズを選択します`,
      path: 'diseaseGroups',
    },
    {
      key: 'occupationGroup',
      title: '職種',
      description: `情報元の職種を選択します`,
      path: 'occupationGroups',
    },
    {
      key: 'workplace',
      title: sourceSegmentsLabel.workplace,
      description: `情報元の${sourceSegmentsLabel.workplace}を選択します`,
      path: 'workplaces',
    },
    {
      key: 'occupation',
      title: '医師カテゴリー',
      description: `情報元の医師カテゴリーを選択します`,
      path: 'occupations',
    },
    {
      key: 'disease',
      title: ciCagetoriesLabel.disease,
      description: `${ciCagetoriesLabel.disease}を選択します`,
      path: 'diseases',
    },
    {
      key: 'productGroup',
      title: '情報種別',
      description: `情報種別を選択します`,
      path: 'productGroups',
    },
    {
      key: 'competitiveProduct',
      title: ciCagetoriesLabel.competitiveProduct,
      description: `${ciCagetoriesLabel.competitiveProduct}を選択します`,
      path: 'competitiveProducts',
    },
    {
      key: 'category',
      title: ciCagetoriesLabel.category,
      description: `${ciCagetoriesLabel.category}を選択します`,
      path: 'categories',
    },
    {
      title: '確認',
      description: '選択内容を確認し、問題なければテキストを入力してください',
    },
  ],
};
